import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Observable } from 'rxjs';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';
import { BaseService } from 'src/app/framework/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class FeeConfigService extends BaseService {

  constructor(private http: HttpClient) {
    super();
  }
  getAllFeeDetails(): Observable<any> {
    return this.httpService.get(APIUrl.getAllFeeDetails);
  }
  addFeeConfig(params: Params): Observable<any> {
    return this.httpService.post(APIUrl.addFee, params);
  }
  allConfigHistory(id:number): Observable<any> {
    return this.httpService.get(`${APIUrl.configHistory}/${id}`);
  }
  getAllFeeDetailsById(id:number): Observable<any> {
    return this.httpService.get(`${APIUrl.feeDetailsById}/${id}`)
  }
  updateFeeDetails(params: Params): Observable<any> {
    return this.httpService.put(APIUrl.editFee, params);
  }
}
